import React from "react";
import CrudResource from "./CrudResource";

const fields = [
  { key: "media_url", label: "Görsel / Video (Dosya, YouTube veya URL)", type: "media", accept: "both", span: 2 },
  { key: "media_type", label: "Tür", type: "select",
    options: [{ value: "image", label: "Görsel" }, { value: "video", label: "Video" }] },
  { key: "caption_tr", label: "Açıklama (TR)" },
  { key: "caption_en", label: "Açıklama (EN)" },
  { key: "order", label: "Sıra", type: "number" },
  { key: "active", label: "Aktif", type: "checkbox" },
];
const defaults = { media_url: "", media_type: "image", caption_tr: "", caption_en: "", order: 100, active: true };

export default function AdminBts() {
  return <CrudResource resource="bts" publicPath="bts" title="Sahne Arkası" fields={fields} defaults={defaults} />;
}
